import { Injectable } from '@angular/core';
import { ParseService } from '../parse/parse.service';
import { HardCodedValues } from '../hard-coded-values';
import { QueryInterface } from '../parse/query-interface';
import { GetOperations } from './dropdown';
import { DatePipe } from '@angular/common';
import { StorageConfiguration } from '../storage-setting/storage-configuration';

@Injectable({
    providedIn: 'root'
})

export class ActivityCenterService {

    currentUser = this.parseService.instance.User.current();
    currencyLists = [];
    organisationLists = [];
    reportList = [];
    roleList = [];
    locationList = [];
    departmentList = [];
    reportingtoList = [];
    clientList = [];

    addons = [
        { value: 'Addon', viewValue: 'Addon' },
        { value: 'Support', viewValue: 'Support' },
        { value: 'Task', viewValue: 'Task' }
    ];
    tenantId: any;
    industryId: any;

    constructor(private parseService: ParseService,
        private hardCodedValues: HardCodedValues,
        private queryInterface: QueryInterface,
        private profileDropDown: GetOperations,
        private storageConfiguration: StorageConfiguration

    ) {
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
        this.industryId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.industryId);
        this.getDropDowns();
        this.getLocation();
        this.getDepartment();
        this.getOrganisation();
        this.getReportingTo();
        this.getRole();
        this.getClient();
    }

    getClient() {
        var clientName = [];
        const result = [];
        this.queryInterface.executeQuery(this.parseService, 'Client', [
            { field: 'name', condition: 'descending' }]).then(results => {
                const jsonText = JSON.stringify(results);
                const clients = JSON.parse(jsonText);
                for (const client of clients) {
                    clientName = client.companyInfo.firstName;
                    this.clientList.push({
                        id: client.objectId,
                        name: clientName.concat(' ' + client.companyInfo.lastName)
                    });
                }
            });
    }

    async getDropDowns() {
        let queryInstance = this.parseService.instance.Object.extend('DataSettings');
        let query = new this.parseService.instance.Query(queryInstance);
        let result = await query.find();
        var dropdownresults = result[0],
            profileDropDownValue = this.profileDropDown.getProfileDropDown(
                dropdownresults
            ),
            currencyObj = this.currencyLists,
            currencyLists = profileDropDownValue.currencySet;

        for (var i = 0; i < currencyLists.length; i++) {
            currencyObj.push(currencyLists[i]);
        }
    }

    async getLocation() {
        let result = [];
        this.queryInterface.executeQuery(this.parseService, 'Location', [{ condition: 'equalTo', field: 'isActive', value: true },
        { field: 'name', condition: 'descending' }]).then(results => {
            for (let i = 0; i < results.length; i++) {
                let jsonText = JSON.stringify(results[i]);
                let locationInfo = JSON.parse(jsonText);
                result.push({ id: locationInfo.objectId, name: locationInfo.name });
            }
            this.locationList = result;
        });
    }

    async getOrganisation() {
        let result = [];
        this.queryInterface.executeQuery(this.parseService, 'Organisation', [{ condition: 'equalTo', field: 'isActive', value: true },
        { field: 'name', condition: 'descending' }]).then(results => {
            for (let i = 0; i < results.length; i++) {
                let jsonText = JSON.stringify(results[i]);
                let organisationInfo = JSON.parse(jsonText);
                result.push({
                    id: organisationInfo.objectId,
                    name: organisationInfo.name
                });
            }
            this.organisationLists = result;
        });
    }

    async getDepartment() {
        let result = [];
        this.queryInterface.executeQuery(this.parseService, 'Department', [{ condition: 'equalTo', field: 'isActive', value: true },
        { field: 'name', condition: 'descending' },
        { condition: 'equalTo', field: 'industry', value: { __type: 'Pointer', className: 'Industry', objectId: this.industryId }}]).then(results => {
            for (let i = 0; i < results.length; i++) {
                let jsonText = JSON.stringify(results[i]);
                let departmentInfo = JSON.parse(jsonText);
                result.push({
                    id: departmentInfo.objectId,
                    name: departmentInfo.name
                });
            }
            this.departmentList = result;
        });
    }

    async getRole() {
        let result = [];
        this.queryInterface.queryRole(this.parseService).then(results => {
            for (let i = 0; i < results.length; i++) {
                let jsonText = JSON.stringify(results[i]);
                let roleInfo = JSON.parse(jsonText);
                result.push({ id: roleInfo.objectId, name: roleInfo.name });
            }
            this.roleList = result;
        });
    }

    async getUserReporterList(result) {
        var reportingList = []
        await result
            .relation('users')
            .query()
            .include('profile')
            .each(function (obj) {
                reportingList.push(obj);
            });
        return reportingList;
    }

    async getReportingTo() {
        let result = []
        this.reportList = [];
        let queryInstance = this.parseService.instance.Object.extend('_Role');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo("reportingTo", true);
        query.equalTo("isActive", true)
        await query.find().then(resutls => {
            resutls.forEach(element => {
                this.getUserReporterList(element).then(resd => {
                    resd.forEach(element => {
                        let profile = element.get('profile')
                        let reporteeId = profile.id
                        let reportee = profile.get("firstName") + " " + profile.get("lastName");
                        let isActive = profile.get("isActive")
                        if (isActive == true) {
                            this.reportList.push({ id: reporteeId, name: reportee, role: profile.get('role').get('name') });
                        }
                    });
                });
            });
            return result;
        })
    }


    getActivity(oldValue, newValue, type): any[] {
        const activities = [];
        // tslint:disable-next-line: forin
        for (const oldproperty in oldValue) {
            for (const newproperty in newValue) {
                if (oldproperty === newproperty) {
                    let activityModel = this.createActivities(oldproperty, oldValue[oldproperty], newValue[newproperty], type);

                    if (activityModel.allow) {
                        if (activityModel.type === 'Array') {
                            activityModel.activity.forEach(element => {
                                activities.push(element);
                            });

                        } else {
                            activities.push(activityModel.activity);
                        }

                    }
                }
            }
        }
        return activities;
    }


    createActivities(property, oldValue, newValue, typeofmodule): any {
        let message = '';
        let messages = [];
        let activity = {};
        let allow = false;
        const type = this.typeCheck((property === 'projectStartDate' || property === 'actualCompletionDate' || property === 'extendedCompletionDate'
            || property === 'resignationAppliedDate' || property === 'resignationAcceptedDate' || property === 'startDate'
            || property === 'endDate') ? newValue._d : newValue);
        switch (type) {

            case 'string':
                if (oldValue !== newValue) {
                    switch (property) {
                        case 'clientName':
                            const newClientName = this.clientList.filter(x => x.id === newValue);
                            const oldClinetName = oldValue !== '' ? this.clientList.filter(x => x.id === oldValue) : '';
                            // tslint:disable-next-line: max-line-length
                            message = oldClinetName === '' ? 'Added a Client Name - ' + newClientName[0].name : 'Changed client name from ' + oldClinetName[0].name + ' to ' + newClientName[0].name;
                            break;
                        case 'addOnType':
                            const newAddOnType = this.addons.filter(x => x.value === newValue);
                            const oldAddOnType = oldValue !== '' ? this.addons.filter(x => x.value === oldValue) : '';
                            // tslint:disable-next-line: max-line-length
                            message = oldAddOnType === '' ? 'Added a AddOn Type - ' + newAddOnType[0].value : 'Changed AddOn Type from ' + oldAddOnType[0].value + ' to ' + newAddOnType[0].value;
                            break;
                        case 'organisationId':
                            const oldOrganisation = oldValue !== '' ? this.organisationLists.filter(x => x.id === oldValue) : '';
                            const newOrganisation = this.organisationLists.filter(x => x.id === newValue);
                            if (newOrganisation.length > 0) {
                                message = oldOrganisation === '' ? 'Added a Organisation - ' + newOrganisation[0].name : 'Changed organisation from ' + oldOrganisation[0].name + ' to ' + newOrganisation[0].name;
                            }
                            break;
                        case 'locationId':
                            const oldLocation = oldValue !== '' ? this.locationList.filter(x => x.id === oldValue) : '';
                            const newLocation = this.locationList.filter(x => x.id === newValue);
                            if (newLocation.length > 0) {
                                message = oldLocation.length === 0 ? 'Added a Location - ' + newLocation[0].name : 'Changed location from ' + oldLocation[0].name + ' to ' + newLocation[0].name;
                            }
                            break;
                        case 'departmentId':
                            const oldDepartment = oldValue !== '' ? this.departmentList.filter(x => x.id === oldValue) : '';
                            const newDepartment = this.departmentList.filter(x => x.id === newValue);
                            if (newDepartment.length > 0) {
                                message = oldDepartment.length === 0 ? 'Added a Department - ' + newDepartment[0].name : 'Changed department from ' + oldDepartment[0].name + ' to ' + newDepartment[0].name;
                            }
                            break;
                        case 'roleId':
                            const oldRole = oldValue !== '' ? this.roleList.filter(x => x.id === oldValue) : '';
                            const newRole = this.roleList.filter(x => x.id === newValue);
                            if (newRole.length > 0) {
                                message = oldRole.length === 0 ? 'Added a Role - ' + newRole[0].name : 'Changed role from ' + oldRole[0].name + ' to ' + newRole[0].name;
                            }
                            break;
                        case 'reporterId':
                            const oldReporting = oldValue !== '' ? this.reportList.filter(x => x.id === oldValue) : '';
                            const newReporting = this.reportList.filter(x => x.id === newValue);
                            if (newReporting.length > 0) {
                                message = oldReporting.length === 0 ? 'Added a Reporting To - ' + newReporting[0].name : 'Changed reporting to from ' + oldReporting[0].name + ' to ' + newReporting[0].name;
                            }
                            break;
                        default:
                            let prop = this.hardCodedValues.getValues(property);

                            const oldformvalue = oldValue !== '' ? oldValue : '';
                            const newformvalue = newValue;
                            message = oldformvalue === '' ? 'Added a ' + typeofmodule + '  ' + (prop) + ' - ' + newformvalue : 'Changed ' + typeofmodule + '  ' + (prop) + ' - ' + ' from ' + oldformvalue + ' to ' + newformvalue;
                            break;
                    }
                    allow = true;
                }
                break;

            case 'Date':
                const datePipe = new DatePipe('en-US');
                const oldDate = datePipe.transform(oldValue, 'MMM dd yyyy');
                const newDate = datePipe.transform(newValue, 'MMM dd yyyy');
                let prop = this.hardCodedValues.getValues(property);

                if (oldDate !== newDate) {
                    message = oldValue == ('' || null) ? 'Added a ' + prop + '  ' + newDate : 'Updated the ' + prop + ' from ' + oldDate + ' to ' + newDate;
                    allow = true;
                }
                break;


            case 'Number':
                if (oldValue !== newValue) {
                    switch (property) {
                        case 'screenShotSyncTime':
                            if (oldValue !== newValue) {
                                let oldVal = oldValue;
                                let newVal = newValue;
                                message = oldVal == '' ? 'Added Screenshot Sync Time ' + newVal : 'Screenshot Sync Time Changed from ' + oldVal + ' to ' + newVal;
                                allow = true;
                                break;
                            }
                        case 'noticePeriod':
                            if (oldValue !== newValue) {
                                let oldVal = oldValue;
                                let newVal = newValue;
                                message = oldVal == '' ? 'Added Notice Period ' + newVal : 'Notice Period Changed from ' + oldVal + ' to ' + newVal;
                                allow = true;
                                break;
                            }

                        default:
                            let prop = this.hardCodedValues.getValues(property);
                            if (oldValue !== newValue) {
                                let oldVal = oldValue;
                                let newVal = newValue;
                                message = oldVal == '' ? 'Added  ' + prop + ' ' + newVal : prop + ' ' + ' Changed from ' + oldVal + ' to ' + newVal;
                                allow = true;
                                break;
                            }
                    }
                    break;
                }
                break;

            case 'Boolean':
                if (oldValue !== newValue) {
                    switch (property) {
                        case 'biggbossStatus':
                            if (oldValue !== newValue) {
                                let oldVal = (oldValue);
                                let newVal = (newValue);
                                message = oldVal == '' ? ' Big Boss Status Enabled' + ' ' + newVal : 'Big Boss Status Disabled';
                                allow = true;
                            }
                            break;
                        case 'virusScan':
                            if (oldValue !== newValue) {
                                let oldVal = (oldValue);
                                let newVal = (newValue);
                                message = oldVal == '' ? 'Added Virus Scan ' + newVal : 'Virus Scan Changed from ' + oldVal + ' to ' + newVal;
                                allow = true;
                            }
                            break;
                        case 'screenshot':
                            if (oldValue !== newValue) {
                                let oldVal = (oldValue);
                                let newVal = (newValue);
                                message = oldVal == '' ? ' Screenshots Enabled  ' : 'Screenshots Disabled';
                                allow = true;
                            }
                            break;
                        case 'isMeeting':
                            if (oldValue !== newValue) {
                                let oldVal = (oldValue);
                                let newVal = (newValue);
                                message = oldVal == '' ? ' Meeting Enabled  ' : 'Meeting Disabled';
                                allow = true;
                            }
                            break;
                        case 'isWebDesktop':
                            if (oldValue !== newValue){
                                const oldVersion =  oldValue ? 'Web Desktop App' : 'Desktop App';
                                const newVersion =  newValue ? 'Web Desktop App' : 'Desktop App';
                                message = 'Desktop version changed from ' + oldVersion + ' to '  + newVersion ;
                                allow = true;
                            }
                            break;
                        case 'isLogin':
                            if (oldValue !== newValue) {
                                let oldVal = (oldValue);
                                let newVal = (newValue);
                                message = oldVal == '' ? ' Login Notification Enabled  ' : 'Login Notification Disabled';
                                allow = true;
                            }
                            break;
                        case 'isLogout':
                            if (oldValue !== newValue) {
                                let oldVal = (oldValue);
                                let newVal = (newValue);
                                message = oldVal == '' ? ' Logout Notification Enabled  ' : 'Logout Notification Disabled';
                                allow = true;
                            }
                            break;
                        case 'isProjectSwitched':
                            if (oldValue !== newValue) {
                                let oldVal = (oldValue);
                                let newVal = (newValue);
                                message = oldVal == '' ? ' Project Switched Notification Enabled  ' : 'Project Switched Notification Disabled';
                                allow = true;
                            }
                            break;
                        default:
                            let oldVal = (oldValue);
                            let newVal = (newValue);
                            message = oldVal === '' ? 'Enabled  ' + property + ' - ' + newVal : 'Changed ' + property + ' - ' + ' from ' + oldVal + ' to ' + newVal;
                            allow = true;
                            break;
                    }
                    break;
                }

            case 'Array':
                switch (property) {
                    case 'projectPlatform':
                        let arrayValue = [];
                        arrayValue = this.arrayDifference(oldValue, newValue);
                        arrayValue.forEach(element => {
                            const val1 = oldValue.includes(element);
                            const val2 = newValue.includes(element);
                            messages.push(val1 === false && val2 === true ? 'Added a Project Platform ' + ' - ' + element : 'Removed a Project Platform ' + ' - ' + element);
                            allow = true;
                        });
                        break;

                    default:
                        if (oldValue != null && newValue != null) {
                            let array = [];
                            array = this.arrayDifference(oldValue, newValue);
                            array.forEach(element => {
                                const val1 = oldValue.includes(element);
                                const val2 = newValue.includes(element);
                                messages.push(val1 === false && val2 === true ? 'Added a ' + property + ' - ' + element : 'Changed a ' + property + ' - ' + element);
                                allow = true;
                            });
                            break;
                        }
                }
                break;
        }

        if (type === 'Array') {
            let act = [];
            messages.forEach(element => {
                act.push(this.setActivityModel(element));
            });
            activity = act;
            return { activity: activity, allow, type };
        } else {
            activity = this.setActivityModel(message);
            return { activity: activity, allow, type };
        }

    }

    typeCheck(Source): string {
        if (Source != null) {
            if (Source.constructor === Array) {
                return 'Array';
            } else if (Source.constructor === Object) {
                return 'object';
            } else if (Source.constructor === String) {
                return 'string';
            } else if (Source.constructor === Date) {
                return 'Date';
            } else if (Source.constructor === Number) {
                return 'Number';
            } else if (Source.constructor === Boolean) {
                return 'Boolean';
            }
        }
    }

    arrayDifference(array1, array2) {
        let array = [];
        array1 = array1.toString().split(',');
        array2 = array2.toString().split(',');
        // for array1
        for (let i in array1) {
            if (array2.indexOf(array1[i]) === -1) {
                array.push(array1[i]);
            }
        }
        // for array2
        for (let i in array2) {
            if (array1.indexOf(array2[i]) === -1) {
                array.push(array2[i]);
            }
        }
        return array.sort((x, y) => x - y);
    }

    setActivityModel(message): any {
        const createrProfile = this.currentUser.get('profile');
        const createrImg = createrProfile.get('profileImageInfo').url;
        const createrName = createrProfile.get('username');
        const activity = {
            message: message,
            createdBy: createrName,
            createdId: createrProfile.id,
            createdDate: new Date().toUTCString(),
            createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
        };
        return activity;
    }

    createActivity(activity, moduleType, id): any {
        activity.forEach(async element => {
            let activityClass = this.parseService.instance.Object.extend('ActivityCenter');
            var activityDetails = new activityClass();
            activityDetails.set("moduleType", moduleType);
            activityDetails.set('tenantId', this.tenantId);
            activityDetails.set("updatedBy", { __type: 'Pointer', className: 'Profile', objectId: element.createdId });
            activityDetails.set("message", element.message);
            activityDetails.set('updatedId', id);
            let res = await activityDetails.save();
        });
    }


}